module.exports = __webpack_public_path__ + "static/media/ML_IconHeader.7c3930b9.png";